/**
 * @generated SignedSource<<bfa860a8899ddbaba99b1f99a420d968>>
 * @relayHash 51d1df84a8472580c828f7b00ba3185b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 995203020f6a506841f9791b8fc38803db71189498df4e95ed96189413750b1c

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildEventsUpcomingCardPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
};
export type GuildEventsUpcomingCardPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"GuildEventsUpcomingCard_guild">;
  } | null | undefined;
};
export type GuildEventsUpcomingCardPaginationQuery = {
  response: GuildEventsUpcomingCardPaginationQuery$data;
  variables: GuildEventsUpcomingCardPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 3,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "START_AT_ASC",
      "ID_ASC"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "UPCOMING"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v10 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v11 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v12 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipLevel",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v9/*: any*/),
            (v10/*: any*/),
            {
              "kind": "Literal",
              "name": "fo",
              "value": "face"
            },
            (v11/*: any*/),
            (v12/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"face\",\"h\":100,\"w\":100})"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v9/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"h\":100,\"w\":100})"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v21 = [
  (v14/*: any*/),
  (v15/*: any*/),
  (v7/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v3/*: any*/)
],
v22 = [
  (v20/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildEventsUpcomingCardPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              }
            ],
            "kind": "FragmentSpread",
            "name": "GuildEventsUpcomingCard_guild"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildEventsUpcomingCardPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "upcomingEvents",
                "args": (v4/*: any*/),
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startAt",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "prettyUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasExternalUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasVenue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visibility",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "coverPhoto",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": "mobileTransformUrl",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "transform",
                                    "value": {
                                      "dpr": 3,
                                      "w": 576
                                    }
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "transformUrl",
                                "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
                              },
                              {
                                "alias": "desktopTransformUrl",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "transform",
                                    "value": {
                                      "dpr": 3,
                                      "w": 200
                                    }
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "transformUrl",
                                "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "eventOwner",
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "primaryPhoto",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "fields": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/)
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "transform"
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "transformUrl",
                                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GuildMembership",
                                    "kind": "LinkedField",
                                    "name": "myMembership",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "type": "Guild",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isMe",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "type": "User",
                                "abstractKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "attendeesByRelevance",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "status": {
                                    "in": [
                                      "ATTENDING_IN_PERSON",
                                      "ATTENDING_VIRTUAL",
                                      "WAITING_IN_PERSON",
                                      "WAITING_VIRTUAL"
                                    ]
                                  }
                                }
                              },
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 8
                              }
                            ],
                            "concreteType": "EventAttendeesConnection",
                            "kind": "LinkedField",
                            "name": "eventAttendeesByRelevance",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventAttendeesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventAttendee",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v21/*: any*/),
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
                          },
                          {
                            "alias": "attendingCount",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "status": {
                                    "in": [
                                      "ATTENDING_IN_PERSON",
                                      "ATTENDING_VIRTUAL"
                                    ]
                                  }
                                }
                              }
                            ],
                            "concreteType": "EventAttendeesConnection",
                            "kind": "LinkedField",
                            "name": "eventAttendees",
                            "plural": false,
                            "selections": (v22/*: any*/),
                            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
                          },
                          {
                            "alias": "waitingCount",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                  "status": {
                                    "in": [
                                      "WAITING_IN_PERSON",
                                      "WAITING_VIRTUAL"
                                    ]
                                  }
                                }
                              }
                            ],
                            "concreteType": "EventAttendeesConnection",
                            "kind": "LinkedField",
                            "name": "eventAttendees",
                            "plural": false,
                            "selections": (v22/*: any*/),
                            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventTicketingTiersConnection",
                            "kind": "LinkedField",
                            "name": "eventTicketingTiers",
                            "plural": false,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventAttendee",
                            "kind": "LinkedField",
                            "name": "myAttendance",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventAttendeeTicketPurchase",
                                "kind": "LinkedField",
                                "name": "ticketPurchase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "stripePaymentIntentStatus",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GuildMembership",
                                    "kind": "LinkedField",
                                    "name": "myMembership",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v23/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Guild",
                                "abstractKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Form",
                            "kind": "LinkedField",
                            "name": "attendeeForm",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedAt",
                            "storageKey": null
                          },
                          {
                            "alias": "eventItemPresentations",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "orderBy",
                                "value": [
                                  "CREATED_AT_ASC",
                                  "ID_ASC"
                                ]
                              }
                            ],
                            "concreteType": "PresentationsConnection",
                            "kind": "LinkedField",
                            "name": "presentations",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresentationsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Presentation",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                      },
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "presenterFirstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "presenterLastName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "presenter",
                                        "plural": false,
                                        "selections": (v21/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "transform",
                                            "value": {
                                              "dpr": 3,
                                              "h": 24,
                                              "w": 24
                                            }
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "guestPresenterAvatarUrl",
                                        "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"h\":24,\"w\":24})"
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "upcomingEvents",
                "args": (v4/*: any*/),
                "filters": [
                  "timeSelection",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "GuildEventsUpcomingCard_guild_upcomingEvents",
                "kind": "LinkedHandle",
                "name": "eventsByTimeSelection"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "995203020f6a506841f9791b8fc38803db71189498df4e95ed96189413750b1c",
    "metadata": {},
    "name": "GuildEventsUpcomingCardPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e6a6797131e7e99aa9d90bcfc97352b9";

export default node;
